/** EST3 labour rate bases — mirrors backend LABOUR_RATE_BASES. */
export const EST3_LABOUR_RATE_BASES = ['NORMAL', 'OT', 'SHIFT', 'ALLOWANCE'] as const;

export type Est3LabourRateBasis = (typeof EST3_LABOUR_RATE_BASES)[number];

export function summarizeLabourComponents(components: any[]): {
  byBasis: Array<{ basis: string; amount: number }>;
  componentTotal: number;
} {
  const map = new Map<string, number>();
  let componentTotal = 0;
  for (const c of components) {
    const basis = String(c.rate_basis || 'NORMAL');
    const amt = Number(c.amount) || 0;
    map.set(basis, (map.get(basis) || 0) + amt);
    componentTotal += amt;
  }
  const byBasis: Array<{ basis: string; amount: number }> = EST3_LABOUR_RATE_BASES.map((basis) => ({
    basis,
    amount: map.get(basis) || 0,
  })).filter((x) => x.amount > 0);
  for (const [basis, amount] of map) {
    if (!EST3_LABOUR_RATE_BASES.includes(basis as Est3LabourRateBasis)) {
      byBasis.push({ basis, amount });
    }
  }
  return { byBasis, componentTotal };
}
